import { useCallback } from 'react'
import type { MeasureOnSuccessCallback, View } from 'react-native'

type ElementLayoutInfoProps = {
  [K in keyof Parameters<MeasureOnSuccessCallback> as K extends `${number}`
    ? 'x' | 'y' | 'width' | 'height' | 'pageX' | 'pageY'
    : never]: Parameters<MeasureOnSuccessCallback>[K]
}

export function useLayoutObserver<T extends React.RefObject<View>>(ref: T) {
  const measureLayout = useCallback(
    (callback: (elementLayout: ElementLayoutInfoProps) => void) => {
      if (ref.current) {
        ref.current.measure((x, y, width, height, pageX, pageY) => {
          const newLayout = {
            x,
            y,
            width,
            height,
            pageX,
            pageY,
          }

          callback(newLayout)
        })
      }
    },
    [ref]
  )

  return {
    measureLayout,
  }
}
